import _ from "lodash";
import * as Yup from "yup";

import { FormGridField } from "../../../../../utils/forms/components/FormGrid";

export const baseConfigInitialFields = _.memoize(
    ( subsidiaries, isDisabled, typeSelectList ): FormGridField[] => [
        {
            name: "name",
            fieldType: "input",
            fieldOptions: {
                id: "name",
                placeholder: "Preset Name",
                inputType: "text",
                label: "Preset Name"
            },
            validation: Yup.string()
                .required("Field is required.")
                .max(20, "Max. 20 characters.")
                .matches(
                    new RegExp(/^[\w\-\ \.]+$/),
                    `Special characters not supported.`
                ),
            columnClass: "col-4",
            formSpacing: false
        },
        {
            name: "subsidiary",
            fieldType: "select",
            fieldOptions: {
                id: "subsidiary_preset",
                noValueLabel: "Choose subsidiary",
                label: "Subsidiary",
                items: subsidiaries,
                disabled: isDisabled
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-4"
        },
        {
            name: "type",
            fieldType: "select",
            fieldOptions: {
                id: "type_preset",
                noValueLabel: "Choose Jackpot Type",
                label: "Jackpot Type",
                items: typeSelectList,
                disabled: isDisabled
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-4"
        }
    ]
);
